import Financials from './components/Financials';

export default Financials;
